export type OtpCodeSendPayload = {
  email: string;
};

export type OtpCodeVerifyPayload = {
  email: string;
  otp: string;
};

export type OtpCodeVerifySuccessPayload = {
  jwt?: string;
};

export type UserModel = {
  name: string;
  mobile: string;
  email: string;
  address: UserAddress;
  userId: string;
  authToken: string;
  guid: string;
  selectedClubId: number;
  userRating: number;
  userImageUrl: string;
  activePaymentMethodOnFile: true;
  confirmDataRequired: true;
  gender: number;
  totalMatchCount: number;
  role: number;
  eWalletBalance: number;
};

export type UserAddress = {
  id: number;
  street: string;
  street2: string;
  zip: number;
  stateCode: string;
  countryCode: string;
  city: string;
  countryName: string;
  stateName: string;
};

export type Player = {
  userId: number;
  name: string;
  email: string;
  userImageUrl: string;
  clubRank: number;
  matchesWon: number;
  userRating: number;
  count: number;
  lastMatchDate: string;
  isGuestPlayer?: boolean;
  totalAmount?: number;
  isAIPlayer?: boolean;
};

export type SpecificBookingSlotsResponse = {
  availableIndoorSlots: SpecificBookingSlots;
  availableOutdoorSlots: SpecificBookingSlots;
  availableSingleSlots: SpecificBookingSlots;
  availableIndoorLegacySlots: SpecificBookingSlots;
};

export type SpecificBookingSlots = {
  bookingSlots: SpecificBookingSlot[];
  minimumPlayingTime: number;
};

export type SpecificBookingSlot = {
  slotName: string;
  startSlotTime: number;
  endSlotTime: number;
  isAvailable: boolean;
};

export type CirclePlayersList = {
  innerCirclePlayers: CirclePlayerMap;
  firstCirclePlayers: CirclePlayerMap;
  secondCirclePlayersWithPbpRating: CirclePlayerMap;
  secondCirclePlayersWithUltraRating: CirclePlayerMap;
  thirdCirclePlayersWithPbpRating: CirclePlayerMap;
  thirdCirclePlayersWithUltraRating: CirclePlayerMap;
};

export type CirclePlayerMap = {
  totalCount: number;
  players: CirclePlayer[];
};

export type CirclePlayer = {
  partnerId: number;
  partnerImageUrl: string;
  frequency: number;
  rating: number;
  name: string;
};

export enum PlayerSelectionBottomSheetType {
  selectPlayers,
  excludePlayers,
  none,
}

export type ProductsServices = {
  categoryName: string;
  categoryId: number;
  products: SubProductsServices[];
  isCategoryHidden: boolean;
};

export type SubProductsServices = {
  id: number;
  name: string;
  netPrice: number;
  taxPrice: number;
  isSharedService: boolean;
  isHidden: boolean;

  // Extra properties for business logic
  categoryId: number;
  count: number;
  totalSalePrice: number;
  selectedPlayers: Player[];
};

export type CourtBookingPayload = {
  bookingDate: string;
  startSlotTime: number;
  endSlotTime: number;
  isRematch: boolean;
  totalAmount: number;
  payments: CourtBookingPayment[];
  courtType: number;
  selectedCircles: number[];
  paymentId: number;
};

export type CourtBookingPlayerProduct = {
  productId: number;
  quantity: number;
  amount: number;
  categId: number;
};

export type CourtBookingPayment = {
  playerId: number;
  includePayment: boolean;
  products: CourtBookingPlayerProduct[];
  "ext-wallet": boolean;
};

export type InvitePlayersPayload = {
  bookingId: number;
  selectedCircles: number[];
  excludedPlayers: number[];
  bookingDate: string;
  startSlotTime: number;
  endSlotTime: number;
  lowerLimit: number;
  upperLimit: number;
  gender: number;
};

export type PaymentCard = {
  verified: boolean;
  active: boolean;
  id: number;
  displayName: string;
  cardBrand: string;
  last4: string;
  validUntil: "2025-04-02T03:22:31.592Z";
  isDefault: true;
};

export type ExternalWalletBalance = {
  balance: number;
};

export type AddPaymentRequestPayload = {
  token: string;
  last4?: string;
  validUntil?: string;
  cardBrand?: string;
  zip?: string;
};

export type BookedCourtsResponse = {
  bookingId: number;
  canCancel: boolean;
  cancellationDescription?: string;
  cancelIsFree: boolean;
  bookingDate: string;
  createdDate: string;
  startSlotTime: number;
  endSlotTime: number;
  players: BookingDetailsResponsePlayers[];
  isHost?: boolean;
};

export type CancelBookingResponse = {
  isSuccess: boolean;
  message: string;
};

export type BookingDetailsResponsePlayers = {
  id: number;
  name: string;
  profileImageUrl: string;
  rating: number;
  countryCode: string;
};

export type PlayerPrices = {
  playerPrices?: PlayerPrice[];
};

export type PlayerPrice = {
  playerId?: number;
  product?: ProductDescription;
};

export type ProductDescription = {
  id?: number;
  name?: string;
  netPrice?: number;
  taxPrice?: number;
  totalPrice?: number;
  isSharedService?: boolean;
  isHidden?: boolean;
};
export type MatchResponsePayload = {
  id: number;
  name: string;
  date: string;
  winningTeamId: number;
  scores: Score[];
  teamA: Team;
  teamB: Team;
  matchBannerImageUrl: string;
  incomplete: boolean;
  // stats: {
  //   clutch: StatsCluthDetails;
  // };
  isScoreFinalized: boolean;
  isScoreConfirmationNeeded: boolean;
  scoresUpdatedBy: number;
  // channelId: string;
  isExternal?: boolean;
  locationName?: string;
  scoresConfirmedBy: number[];
  isGuestUsersPresent: boolean;
  isEditable?: boolean;
  isAnyScoreAdded?: boolean;
  matchState?: number;
  videoData?: MatchVideo[];
  videoIndicator?: string;
};
export type Score = {
  setNumber: number;
  scoreId: number;
  score: number;
  teamId: number;
  matchId: number;
  editableUntil: string;
};
export type Team = {
  id: number;
  name: string;
  playerA: PlayerDetails;
  playerB: PlayerDetails;
};
export type MatchVideo = {
  type?: string;
  url?: string;
  thumbnailUrl?: string;
  label?: string;
  videoId?: string;
};
export type PlayerDetails = {
  playerId: number;
  playerName: string;
  playerImageUrl: string;
  isGuestUser: boolean;
};

export type MatchClutchStatsResponse = {
  apiPlayerDetectedShots?: PlayerIndividualStats[];
  playerStatistics?: PlayerStatistics[];
  matchStatsDetails?: MatchStatsDetails;
};

export type MatchStatsDetails = {
  matchTimeMinutes: number;
  matchTimeInPlayMinutes: number;
  avgRallyShots: number;
  avgRallySeconds: number;
  longestRallyShots: number;
  longestRallySeconds: number;
};

export type PlayerStatistics = {
  resPartnerId: number;
  playerStatsDetails: PlayerStatsDetails[];
};

export type PlayerStatsDetails = {
  consistency: number;
  attack: number;
  physicality: number;
  numberOfShots: number;
  shotQuality: number;
  clutchScore: number;
  courtCoverage: number;
  distanceRunMeters: number;
};

export type PlayerIndividualStats = {
  individualStats?: MatchCluthIndividualStats[];
};

export type MatchCluthIndividualStats = {
  resPartnerId?: number;
  playerDetectedShotsList?: PlayerDetectedShots[];
};

export type PlayerDetectedShots = {
  shotLabel?: string;
  zone?: number;
  shotDirection?: string;
  normalizedCoordinates?: string;
};

export type PlayerCalculatedStats = {
  id?: number;
  percentage: number;
  value: number;
};

export type MatchUserList = {
  userId?: string;
  name?: string;
  email?: string;
  userImageUrl?: string;
  clubRank?: number;
  matchesWon?: number;
  userRating?: number;
  count?: number;
  lastMatchDate?: string;
  teamId?: number;
};
export type AllPlayersProgressCpmparisonType = {
  title: string;
  showPercentage?: boolean;
  player1: PlayerCalculatedStats;
  player2: PlayerCalculatedStats;
  player3: PlayerCalculatedStats;
  player4: PlayerCalculatedStats;
};

export type PlayerStatsComparisonType = {
  title: string;
  showPercentage?: boolean;
  player1: PlayerCalculatedStats;
  player2: PlayerCalculatedStats;
};
